import { useState } from 'react';

export default function useToken() {
    const getToken = () => {
        // const tokenString = sessionStorage.getItem('token');
        const tokenString = localStorage.getItem('kalimera-token');

        const sessionTokenString = sessionStorage.getItem('token');
        if (!sessionTokenString) {
            // other components use token from sessionStorage
            sessionStorage.setItem('token', tokenString);
            const username = localStorage.getItem('kalimera-username');
            const permissions = localStorage.getItem('kalimera-permissions');
            const userID = localStorage.getItem('kalimera-userID');
            const companyID = localStorage.getItem('kalimera-companyID');

            // setUserName(username);
            sessionStorage.setItem('username', username);
            sessionStorage.setItem('permissions', permissions);
            sessionStorage.setItem('userID', userID);
            sessionStorage.setItem('companyID', companyID);
        }

        return tokenString;
    };

    const [token, setToken] = useState(getToken());

    const saveToken = (userToken) => {
        sessionStorage.setItem('token', JSON.stringify(userToken));
        localStorage.setItem('kalimera-token', JSON.stringify(userToken));
        setToken(userToken);
        window.location.reload(); // this is to reload menu with updated permissions
    };

    return {
        setToken: saveToken,
        token
    };
}
